import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'


const injectIntl = <T extends object>(ComposedComponent) =>

  class InjectIntl extends PureComponent<T> {

    static WrappedComponent = ComposedComponent

    static displayName = `injectIntl(${ComposedComponent.displayName || ComposedComponent.name})`

    static contextTypes = {
      intlData: PropTypes.object,
    }

    render() {
      const { intlData: { intl } } = this.context

      return (
        <ComposedComponent
          {...this.props}
          intl={intl}
        />
      )
    }
  }


export default injectIntl
